import legoEventBus from '@/lego-component/utils/eventBus/eventBus';

const searchStore = {
  namespaced: true,
  state: () => ({
    isResetFilterXss: false
  }),
  mutations: {
    resetFilterXss: (state, payload) => {
      state.isResetFilterXss = payload;
    }
  },
  actions: {
    setResetFilterXss: (store) => {
      store.commit('resetFilterXss', true);
    },
    setDefaultResetFilterXss: (store) => store.commit('resetFilterXss', false)
  },
  getters: {
    getResetFilterXss: (state) => {
      return state.isResetFilterXss;
    }
  }
};
export default searchStore;
